import { DataManager } from '@syncfusion/ej2-data';
import { CustomDataOptions } from 'src/app/model/custom-data-options';
import { CustomUrlAdaptor } from './custom-url-adaptor';

export class CustomDataManager extends DataManager {
    constructor(options: CustomDataOptions) {
        super({
            ...options,
            adaptor: new CustomUrlAdaptor(options, options.statsCallback),
        });
    }
}
